import classNames from "classnames";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

import IconGift from "@/icons/icon-gift";
import IconGiftCard from "@/icons/icon-gift-card";
import IconKikoId from "@/icons/icon-kiko-id";
import IconReturnsDays from "@/icons/icon-returns-days";
import myaccount from "~/components/common/myaccount.module.scss";
import { useFavouriteStore } from "~/contexts/favourite-store";

import LinkWrapper from "../common/link-wrapper";
import PreferredStoreModalWrapper from "../stores/preferred-store-modal-wrapper";
import { getOpeningHours } from "../stores/stores-modal";
import styles from "./preferred-store.module.scss";

// used in specific myaccount page
export default function PreferredStore() {
  const t = useTranslations();
  const { preferredStore } = useFavouriteStore();
  const router = useRouter();

  return (
    <>
      <div className={classNames(myaccount.myaccountCard, styles.preferredStoreCard)}>
        <div className={myaccount.myaccountCardHeader}>
          <h1 className={myaccount.preferredStoreTitleDesktop}>{t("generic.myaccount.dashboard.myPreferredStore")}</h1>
          <h2 className={myaccount.preferredStoreTitleMobile}>{t("generic.myaccount.dashboard.myPreferredStore")}</h2>
        </div>
        <div className={classNames(myaccount.myaccountCardContent, styles.preferredStoreContent)}>
          <div className={styles.preferredStore}>
            <h2 className={styles.preferredStoreNameDesktop}>
              {preferredStore ? preferredStore.Name : t("generic.storenotselectedyet")}
            </h2>
            <h3 className={styles.preferredStoreNameMobile}>
              {preferredStore ? preferredStore.Name : t("generic.storenotselectedyet")}
            </h3>
            {preferredStore ? (
              <>
                {preferredStore.Address && (
                  <p>
                    {preferredStore.Address.Address1}
                    {preferredStore.Address.City ? `, ${preferredStore.Address.City}` : ""}
                    {preferredStore.Address.CountryID ? `, ${preferredStore.Address.CountryID}` : ""}
                    {preferredStore.Address.PhoneNumber ? (
                      <>
                        {` · `}
                        <a href={`tel:${preferredStore.Address.PhoneNumber}`}>{preferredStore.Address.PhoneNumber}</a>
                      </>
                    ) : (
                      ""
                    )}
                  </p>
                )}
                <br />
                {preferredStore.Latitude != undefined && preferredStore.Longitude != undefined && (
                  <LinkWrapper
                    target="_blank"
                    href={`https://www.google.com/maps/search/?api=1&query=${preferredStore.Latitude}%2C${preferredStore.Longitude}`}
                  >
                    {t("generic.getdirections")}
                  </LinkWrapper>
                )}
              </>
            ) : (
              <p>{t("generic.storenotselectedyetdesc")}</p>
            )}
          </div>
          {preferredStore &&
            getOpeningHours(preferredStore.RegularOpeningHours, router.locale, t("generic.storeOpeningHours"))}
          {/* TODO understand if those info will ever come */}
          {/* <div className={styles.services}>
            <h3 className={styles.preferredStoreName}>Available services:</h3>
            <ul>
              <li>
                <Icon icon={IconGift} aria-hidden width={16} height={16} className={styles.paymentCardIcon} />
                <p>Gift wrapping</p>
              </li>
              <li>
                <Icon icon={IconReturnsDays} aria-hidden width={16} height={16} className={styles.paymentCardIcon} />
                <p>Return in store</p>
              </li>
              <li>
                <Icon icon={IconGiftCard} aria-hidden width={16} height={16} className={styles.paymentCardIcon} />
                <p>Gift card</p>
              </li>
              <li>
                <Icon icon={IconKikoId} aria-hidden width={16} height={16} className={styles.paymentCardIcon} />
                <p>Kiko ID</p>
              </li>
            </ul>
          </div> */}
          {/* <div className={styles.nextEvent}>
            <h3 className={styles.preferredStoreName}>Next event:</h3>
            <div className={styles.event}>
              <h4>Spring beauty event</h4>
              <div>
                <p>10th May 23</p>
                <LinkWrapper href="#">Save the date</LinkWrapper>
              </div>
            </div>
          </div> */}
          <div className={styles.actions}>
            <PreferredStoreModalWrapper />
          </div>
        </div>
      </div>
    </>
  );
}
